import $ from 'jquery';

const $html = $(document.documentElement);
const $visionbar = $('.visionbar');
const $textSize = $('.visionbar__text-size');
const $contrast = $('.visionbar__contrast');


$visionbar.find('.visionbar__open').on('click', ev => {
    ev.preventDefault();
    $visionbar.toggleClass('visionbar--open');
});

$visionbar.find('a:not(.visionbar__open)').on('focus', ev => {
    ev.preventDefault();
    $visionbar.addClass('visionbar--focus');
});

$('body *').on('focus', ev => {
    if($(ev.target).closest('.visionbar').length < 1 || $(ev.target).hasClass('visionbar__open')) {
        $visionbar.removeClass('visionbar--focus');
    }
});

function getVisionSettings() {
    const settings = localStorage.getItem('vision-settings');
    return settings ? JSON.parse(settings) : {
        'large-text': false,
        'high-contrast': false
    };
}

function updateVisionSetting(setting, value) {
    const settings = getVisionSettings();
    settings[setting] = value;
    localStorage.setItem('vision-settings', JSON.stringify(settings));
}

function toggleMode(clsName, $button) {
    $html.toggleClass(clsName);
    if ($html.hasClass(clsName)) {
        $button.addClass('active')
        updateVisionSetting(clsName, true);
    } else {
        $button.removeClass('active')
        updateVisionSetting(clsName, false);
    }
}

$textSize.on('click', ev => {
    ev.preventDefault();
    toggleMode('large-text', $textSize)
});

$contrast.on('click', ev => {
    ev.preventDefault();
    toggleMode('high-contrast', $contrast)
});

const settings = getVisionSettings();
if (settings['large-text']) {
    $html.addClass('large-text');
    $visionbar.addClass('visionbar--open');
    $textSize.addClass('active');
}
if (settings['high-contrast']) {
    $html.addClass('high-contrast');
    $visionbar.addClass('visionbar--open');
    $contrast.addClass('active');
}
